import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setArray,
  decreaseUnreadCount
} from 'store/redux/notifications'

export default function * requestMarkTaggedNotificationsAsRead (action) {
  const { tag } = action.payload

  const state = yield select()

  let array = []
  let currentArray = []

  state.kanbo.notifications.notifications.forEach(id => {
    const notification = state.kanbo.notifications.notificationsById[id]
    if (!notification.wasRead) {
      const length = notification.tags.length
      for (let i = 0; i < length; i++) {
        if (notification.tags && notification.tags.indexOf(tag) >= 0) {
          array.push({
            id,
            wasRead: true
          })
          currentArray.push({
            id,
            wasRead: notification.wasRead
          })

          break
        }
      }
    }
  })

  const unreadCount = array.length

  const optimisticAction = yield optimisticPut([
    setArray(array),
    decreaseUnreadCount({
      unreadCount
    })
  ])

  try {
    yield call(apiAction, 'MarkTaggedNotificationsAsRead', {
      tag
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}

